<template>
	<div
		class="post-comment display-flex flex-align-start pt-2"
		:class="{ contained: containedMode }"
		@keyup.enter="addComment"
		@keyup.esc="dismiss"
	>
		<div class="flex-centerize flex-wrap flex-1">
			<div class="flex-col-1">
				<AppTooltip :position="'top'" :text="commenterUser.name">
					<SettingsManageUsersInfoAvatar initials :user="commenterUser" :size="25" />
				</AppTooltip>
			</div>
			<div class="flex-col-11 pr-5">
				<AppTextField
					ref="input"
					class="comment-input"
					v-model="comment"
					placeholder="Add a comment - how would you implement this for your team?"
					outlined
					:disabled="disabled"
				/>
			</div>
			<div class="flex-col-12 flex-end--end pr-5 pt-2" v-if="containedMode || loading">
				<DismissSaveButtons @dismiss="dismiss" @save="addComment" :isLoading="loading" :allowDismiss="false" />
			</div>
		</div>
	</div>
</template>

<script>
import DismissSaveButtons from '@/components/InspirationCenter/DismissSaveButtons.vue';
import SettingsManageUsersInfoAvatar from '@/components/SettingsManageUsersInfoAvatar.vue';
import { teamMemberByUserId } from '@/store/modules/account/getters';
import { user } from '@/store/modules/auth/getters';
import { addIdeaComment } from '@/store/modules/inspirationCenter/actions';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'IdeaCommentPost',
	props: { ideaId: { type: String }, containedMode: { type: Boolean, default: false }, disabled: { type: Boolean } },
	computed: {
		...mapGettersShorthand({ user, teamMemberByUserId }),
		commenterUser() {
			return this.teamMemberByUserId(this.user.id);
		},
	},
	data() {
		return {
			comment: '',
			loading: false,
		};
	},
	methods: {
		...mapActionsShorthand({ addIdeaComment }),
		async addComment() {
			if (this.disabled) {
				return;
			}
			if (!this.comment.trim()) {
				return;
			}
			this.loading = true;
			try {
				const newComment = await this.addIdeaComment({ ideaId: this.ideaId, content: this.comment });
				this.$emit('comment-added', { commentId: newComment.id });
				this.comment = '';
			} finally {
				this.loading = false;
			}
		},
		focus() {
			this.$refs.input.focus();
		},
		dismiss() {
			this.comment = '';
			this.$emit('dismiss');
		},
	},
	components: { SettingsManageUsersInfoAvatar, DismissSaveButtons },
};
</script>

<style lang="scss" scoped>
.post-comment {
	background: #f7f7f9;
	border: 1px solid var(--tertiary-border-color);
	border-radius: 9px;
	height: 78px;
	&.contained {
		border-top-left-radius: 0px;
		border-top-right-radius: 0px;
	}
	.comment-input {
		::v-deep {
			.v-input {
				font-size: 14px;
				height: 35px;
				.v-input__control {
					min-height: 35px;
				}
			}
		}
	}
}
</style>
